import { render, staticRenderFns } from "./_listPriceTiersModal.vue?vue&type=template&id=68d5dd52"
import script from "./_listPriceTiersModal.vue?vue&type=script&lang=js"
export * from "./_listPriceTiersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports